import React from 'react';
import {
  PaymentLogos,
  StyledTextPairing,
  DisplayAboveMobileCloudImage,
  DisplayOnMobileCloudImage,
  StyledFlex,
  TextWrapper,
  StyledCloudImage,
  StyledGetStartedButton,
} from './ZeroCashFundSection.styles';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { babyRegistryPageData } from '@data-ts/pages/baby-registry';

const babyRegistryCashfundsData = babyRegistryPageData.cashFunds;

export const ZeroCashFundSection: React.FC = () => {
  return (
    <Box as="section" id="BabyRegistry_ZeroCashFund" marginTop={6} marginX={[4, 8]}>
      <StyledFlex justifyContent="flex-start" alignItems="center" flexDirection="column">
        <TextWrapper flexDirection="column" alignItems="center" paddingX={5} paddingTop={[9, 85]} paddingBottom={[0, 100]}>
          <StyledTextPairing
            eyebrow={babyRegistryCashfundsData.eyebrow}
            eyebrowColor="red5"
            eyebrowVariant="sectionEyeBrow20"
            title={babyRegistryCashfundsData.title}
            titleVariant="hed56"
            titleColor="neutra6"
            titleTagName="h3"
            body={babyRegistryCashfundsData.body}
            bodyVariant="dek20"
            bodyColor="neutra5"
            alignment="center"
            titleMaxWidth="360px"
            bodyMaxWidth="320px"
          />
          <StyledGetStartedButton id="babyRegistryCashFundGetStartedBtn" variant="secondary" page={'baby-registry'}>
            {babyRegistryCashfundsData.getStarted}
          </StyledGetStartedButton>
          <Text variant="sectionEyeBrow20" tagName="p" color="neutra5" textAlign="center" margin={[0, 5]} paddingTop={[3, 0]}>
            {babyRegistryCashfundsData.cardTitle}
          </Text>
          <PaymentLogos paddingTop={[6, 0]} justifyContent="center">
            <StyledCloudImage src="baby-registry/cash-funds/logos/logo-venmo.svg" optimization="default" />
            <StyledCloudImage src="baby-registry/cash-funds/logos/cashapp.svg" optimization="default" />
            <StyledCloudImage src="baby-registry/cash-funds/logos/paypal.svg" optimization="default" />
          </PaymentLogos>
        </TextWrapper>
        <DisplayOnMobileCloudImage
          alt={babyRegistryCashfundsData.title}
          src={babyRegistryCashfundsData.srcMobile}
          width="100%"
          optimization="default"
        />
      </StyledFlex>
      <DisplayAboveMobileCloudImage
        alt={babyRegistryCashfundsData.title}
        src={babyRegistryCashfundsData.src}
        width="100%"
        optimization="default"
      />
    </Box>
  );
};
